import { createRequest } from '../shared/utils/request';
import { ReqParams, OrderReqParams } from './types';
import { getEnvUrlPrefix } from '../shared/utils/multiRegionUtil';

const spBaseUrl = `https://sp.spx.${getEnvUrlPrefix()}shopee.com.my`;
const debugUrl = 'http://10.12.112.48:8000';

export const spRequest = createRequest(spBaseUrl, {
  withCredentials: true,
});
export const debugRequest = createRequest(debugUrl, {
  withCredentials: true,
});
export const getSMSContent = (params: ReqParams) =>
  spRequest.get('/sp-openapi/collection/barcode/sms', { params });

export const getInOrderContent = (params: OrderReqParams) =>
  spRequest.get('/sp-openapi/collection/barcode/app', { params });

export const getPermission = () => spRequest.get('/sp-api/feature');

export default {
  getSMSContent,
  getInOrderContent,
  getPermission,
};
